module.exports = __webpack_public_path__ + "static/step-1.1473733a.png";